import { Component } from 'react';
import { Button } from "react-bootstrap";
import { v4 as uuid } from 'uuid';
import GameData from "../mobx/GameData";
import { observe } from 'mobx';
import NewGameDialog from "../components/NewGameDialog";
import ApplicationState from "../mobx/ApplicationState";
import { ChrFile } from "../components/nes/ChrFile";
import { CONSTANTS } from '../config/Constants';
/*
const t = 
[7,15,15,31,63,63,63,47,0,0,12,20,18,27,31,29,224,240,240,248,252,252,252,244,0,0,48,40,72,216,248,184,7,15,15,31,63,63,63,47,0,0,12,20,18,27,31,29,224,240,240,248,252,252,252,244,0,0,48,40,72,216,248,184,12,28,62,63,63,47,63,63,12,28,30,31,31,31,30,13,48,56,124,252,252,244,252,252,48,56,120,248,248,248,120,176,12,28,62,63,63,47,63,63,12,28,30,31,31,31,30,13,48,56,124,252,252,244,252,252,48,56,120,248,248,248,120,176,0,3,7,7,7,35,98,243,0,3,2,2,3,33,97,113,192,224,240,248,252,255,255,255,0,0,128,120,124,246,247,255,0,3,7,7,7,35,98,243,0,3,2,2,3,33,97,113,192,224,240,248,252,255,255,255,0,0,128,120,124,246,247,255,3,7,15,31,63,255,255,255,0,0,1,30,62,111,239,255,0,192,224,224,224,196,70,207,0,192,64,64,192,132,134,142,3,7,15,31,63,255,255,255,0,0,1,30,62,111,239,255,0,192,224,224,224,196,70,207,0,192,64,64,192,132,134,142,63,63,63,63,63,63,63,31,29,15,19,26,28,15,14,6,252,252,252,252,252,252,252,248,184,240,200,88,56,240,112,96,63,63,63,63,63,63,63,31,29,15,19,26,28,15,14,6,252,252,252,252,252,252,252,248,184,240,200,88,56,240,112,96,63,63,63,63,63,63,63,31,13,27,27,29,31,30,12,12,252,252,252,252,252,252,252,248,176,216,216,184,248,120,48,48,63,63,63,63,63,63,63,31,13,27,27,29,31,30,12,12,252,252,252,252,252,252,252,248,176,216,216,184,248,120,48,48,255,255,127,63,62,126,127,63,62,127,63,15,31,31,28,24,255,254,252,252,244,246,254,252,222,224,248,248,248,120,48,48,255,255,127,63,62,126,127,63,62,127,63,15,31,31,28,24,255,254,252,252,244,246,254,252,222,224,248,248,248,120,48,48,255,127,63,63,47,111,127,63,123,7,31,31,31,30,12,12,255,255,254,252,124,126,254,252,124,254,252,240,248,248,56,24,255,127,63,63,47,111,127,63,123,7,31,31,31,30,12,12,255,255,254,252,124,126,254,252,124,254,252,240,248,248,56,24]
;
*/
export default class SciencePage extends Component {

    thisId = null;
    gameDataCleanup = null;

    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);

        this.state = {
        }

        /* Convert old-style zoria to new 
        this.state.currentTiles = [
            ...t.slice(0, 32), 
            ...t.slice(0, 32), 
            ...t.slice(0, 32), 
            // BACK Anim
            // ...t.slice(64, 64+32),
            ...t.slice(128, 128+32),
            ...t.slice(128, 128+32),
            ...t.slice(128, 128+32),
            ...Array(256 - 32*6).fill(0),
            ...t.slice(256, 256 + 32),
            ...t.slice(256, 256 + 32),
            ...t.slice(256, 256 + 32),

            ...t.slice(256 + 128, 256 + 128 + 32),
            ...t.slice(256 + 128, 256 + 128 + 32),
            ...t.slice(256 + 128, 256 + 128 + 32),
            ...Array(256 - 32*6).fill(0),

            ...t.slice(64, 64+32),
            ...t.slice(64, 64+32),
            ...t.slice(64, 64+32),
            ...t.slice(192, 192+32),
            ...t.slice(192, 192+32),
            ...t.slice(192, 192+32),
            ...Array(256 - 32*6).fill(0),
            ...t.slice(256 + 64, 256 + (32*3)),
            ...t.slice(256 + 64, 256 + (32*3)),
            ...t.slice(256 + 64, 256 + (32*3)),
            ...t.slice(256 + 192, 256 + 192 + 32),
            ...t.slice(256 + 192, 256 + 192 + 32),
            ...t.slice(256 + 192, 256 + 192 + 32),
            ...Array(256 - 32*6).fill(0)
            // BACK anim
            // ...t.slice(256 + 64, 256 + (32*3))
        ]
        console.info('drawn', this.state.currentTiles)
        console.info(JSON.stringify(this.state.currentTiles));

        // this.state.currentTiles = t;
        */
    }

    async componentDidMount() {
        this.gameDataCleanup = observe(GameData, () => { 
            this.forceRefresh()
        });

        this.BuiltInSprites = (await import('../data/BuiltInSprites')).default;
        this.forceUpdate();
    }

    componentWillUnmount() {
        if (this.gameDataCleanup) {
            this.gameDataCleanup();
        }
    }

    addThing() {
        this.thisId = uuid();
        GameData.addGame({id: this.thisId, 'title': 'INSERT BEEF'});

    }

    removeThing() {
        GameData.removeGame(this.thisId);
    }

    async angusRoastBeef(includeBaseData) {

        // Document it and this works! Sans sfx
        // How to make it work?
        // 1. Download zip
        // 2. Download create-nes-game
        // 3. create-nes-game download-dependencies
        // 4. create-nes-game build
        // 5. create-nes-game run
        const jszip = (await import('jszip')).default;
        let zip
        // FIXME trycatch
        const game = GameData.currentGame,
            root = `nes-puzzle-maker-rom-${CONSTANTS.GithubTag}`;
        
        if (includeBaseData) {
            const rawdata = await (await fetch(CONSTANTS.ZipDownloadUrl)).arrayBuffer();
            zip = await jszip.loadAsync(rawdata);
        } else {
            zip = new jszip();
        }

        const patchableDataTxt = await GameData.generatePatchableDataForCurrentRom();
        zip.file(`${root}/source/assembly/library/patchable_data.asm`, patchableDataTxt);
        // NOTE: Can't do sound due to how I import it. Kinda just living with that. If you really really
        // want it, add it in the defined spot.
        if (game.soundtrackData && game.soundtrackData.length > 0) {
            zip.file(`${root}/sound/music.bin`, new Uint8Array(game.soundtrackData))
        }
        zip.file(`${root}/graphics/tiles_mod.chr`, new Uint8Array(game.gameGraphicsTiles))
        zip.file(`${root}/graphics/sprites_mod.chr`, new Uint8Array(game.gameGraphicsSprites))
        zip.file(`${root}/graphics/ascii_mod.chr`, new Uint8Array(game.gameGraphicsFont))

        const result = await zip.generateAsync({type: 'base64'});
        
        const a = document.createElement('a');
        a.setAttribute('href', 'data:application/zip;base64,' + result);
        a.setAttribute('download', 'game.zip');
        a.click();
    }

    render() {
        const { userGames } = GameData;
        return (
            <div>
                <h1>Science</h1>

                <Button onClick={event => this.addThing(event)}>Add Thing</Button>
                <Button onClick={event => this.removeThing(event)}>Remove thing</Button>
                <Button onClick={event => GameData.reset()}>Reset Emulator</Button>
                <Button onClick={event => this.angusRoastBeef(true)}>download zip</Button>
                <Button onClick={event => this.angusRoastBeef(false)}>Download zip diff</Button>
                <NewGameDialog />
                <br />
                <Button onClick={() => ApplicationState.addAlert('info', 'Hello there')}>Alert me</Button>
                
                {userGames.map(game => {
                    return <Button variant="secondary" key={game.id} onClick={() => GameData.setCurrentGame(game.id)}>{game.id}</Button>
                })}
                
                <div>
                    {this.BuiltInSprites?.map(a => {
                        return <div style={{display: 'inline-block', margin: '4px'}}><ChrFile data={a.data} palette={[0x0f, 0x11, 0x21, 0x31]} /></div>
                    })}
                </div>
                <hr></hr>
                <ChrFile data={this.state.currentTiles} palette={[0x0f, 0x11, 0x21, 0x31]} />
            </div>
        );
    }
}